module.exports = __webpack_public_path__ + "img/6.603d4033.jpg";